var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 774.05 440.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252830;opacity:0.4;}.cls-2{font-size:260px;font-family:SFProDisplay-Regular, SF Pro Display;letter-spacing:0.05em;}.cls-2,.cls-5{fill:#fbb019;}.cls-3{fill:none;stroke:#3e4653;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#525a67;}.cls-6{fill:#3e4653;}.cls-7{fill:#525b69;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "500_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.65,131.87c-34.27,11.06-74,28.29-80.31,63.74C4.2,218.7,17.61,242.87,37.82,254.8c9.86,5.83,22,9.93,27.12,20.15,8,15.89-6.39,34.11-21.6,43.35s-33.76,16.57-40.68,33C-1.9,362.07-.11,374.65,4.4,385.48,21,425.17,69.28,442.56,112.24,440.43S196,421.57,238.09,413c144.72-29.6,296.45,37.57,440.92,6.79,22.49-4.79,45.13-12.29,62.49-27.35,19.58-17,30.69-42.59,32.36-68.44,1.6-24.67-7.14-52.44-29.22-63.56-12.9-6.49-28.32-6.23-42.32-2.69-9,2.25-17.74,5.79-27,5.85S656,259,653.31,250.17c-2.81-9.29,3.6-18.87,10.94-25.2,14.94-12.88,34.92-19.32,48.49-33.64a57.29,57.29,0,0,0-22.42-93.39c-45.59-16.18-95.27,27.94-141.89,15-3.46-1-7.1-2.44-8.92-5.53s-1.37-6.86-.35-10.21c5.71-18.77,27.89-30.72,28.86-50.32.53-10.66-5.76-20.62-13.71-27.75-54.55-48.95-133.6,9.28-189.23,27.66C273.61,77,180.37,102.27,88.65,131.87Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(152.22 293.6)"
  }, "5"), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 386.52,
    y1: 1.82,
    x2: 386.52,
    y2: 129.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 352.52,
    y1: 67.82,
    x2: 352.52,
    y2: 108.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.52,
    y1: 28.82,
    x2: 421.52,
    y2: 98.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 328.06,
    y: 153.76,
    width: 117.92,
    height: 17.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.34,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 337.27,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.2,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.13,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 355.06,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 360.99,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.92,
    y: 156.94,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 328.06,
    y: 170.77,
    width: 117.92,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 195.43,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 189.18,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 180.15,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 173.98,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 176.98,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 176.98,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 176.98,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 220.21,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 213.96,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 204.93,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 198.76,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 201.76,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 201.76,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 201.76,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 244.99,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 238.74,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 229.71,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 223.54,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 226.54,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 226.54,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 226.54,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 269.77,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 263.52,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 254.49,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 248.32,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 251.32,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 251.32,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 251.32,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 294.55,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 288.3,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 279.27,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 273.1,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 276.1,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 276.1,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 276.1,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 319.33,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 313.08,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 304.05,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 297.88,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 300.88,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 300.88,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 300.88,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 329.83,
    y: 344.11,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 337.86,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 328.83,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 322.66,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 325.66,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 325.66,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 325.66,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 362.64,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.83,
    y: 353.61,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 347.44,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.31,
    y: 350.44,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.12,
    y: 350.44,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.92,
    y: 350.44,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 328.06,
    y: 369.04,
    width: 117.93,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.06,
    y: 372.36,
    width: 117.93,
    height: 17.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 332.13,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 339.01,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 332.13,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 339.01,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 381.01,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 387.88,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 381.01,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 387.88,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 431.79,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 438.66,
    y: 375.94,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 431.79,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 438.66,
    y: 382.78,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 472.77,
    y: 62.43,
    width: 117.92,
    height: 17.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.05,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 481.97,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.9,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 493.83,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.76,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 505.69,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 511.62,
    y: 65.61,
    width: 3.01,
    height: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 472.77,
    y: 79.44,
    width: 117.92,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 104.1,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 97.84,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 88.82,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 82.65,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 85.65,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 85.65,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 85.65,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 128.88,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 122.62,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 113.6,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 107.43,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 110.43,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 110.43,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 110.43,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 153.66,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 147.4,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 138.38,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 132.21,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 135.21,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 135.21,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 135.21,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 178.44,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 172.18,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 163.16,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 156.99,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 159.99,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 159.99,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 159.99,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 203.22,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 196.96,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 187.94,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 181.77,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 184.77,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 184.77,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 184.77,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 228,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 221.74,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 212.72,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 206.54,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 209.55,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 209.55,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 209.55,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 474.54,
    y: 252.78,
    width: 114.38,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 246.52,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 237.5,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 231.32,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 234.33,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 234.33,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 234.33,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 271.3,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.54,
    y: 262.28,
    width: 114.38,
    height: 9.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.77,
    y: 256.1,
    width: 117.92,
    height: 6.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 476.02,
    y: 259.11,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.82,
    y: 259.11,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 499.62,
    y: 259.11,
    width: 8.91,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 472.76,
    y: 277.71,
    width: 117.93,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 472.76,
    y: 281.03,
    width: 117.93,
    height: 17.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 476.84,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.71,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 476.84,
    y: 291.44,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.71,
    y: 291.44,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 525.71,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 532.59,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 525.71,
    y: 291.44,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 532.59,
    y: 291.44,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 576.49,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 583.36,
    y: 284.61,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 576.49,
    y: 291.44,
    width: 3.34,
    height: 3.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 583.36,
    y: 291.44,
    width: 3.34,
    height: 3.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.fea9171aa011bb291c2db996338bbf6c.svg";
export { ForwardRef as ReactComponent };